import { type FC, useEffect, useState } from "react";
import { Select, type SelectOptionType } from "@onshopfront/components";
import { useShopfrontDispatch } from "../../_Bootstrap/hooks";
import { hideDialog } from "../../Actions/Dialogs/DialogActions";
import Button from "../../Common/Buttons/Button";
import { determineDataSource } from "../../Data/DataStores/DataSource";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";

interface Props {
    user: string | null;
    onSelect: (user: string) => void;
}

export const DashboardUserSelect: FC<Props> = ({ user, onSelect }) => {
    const dispatch = useShopfrontDispatch();

    const [ selected, setSelected ] = useState<null | SelectOptionType<string>>(null);
    const [ options, setOptions ] = useState<Array<SelectOptionType<string>>>([]);
    const [ loading, setLoading ] = useState(true);

    useEffect(() => {
        setLoading(true);

        determineDataSource()
            .then(source => source.users.all())
            .then(localUsers => {
                let prevSelected: null | SelectOptionType<string> = null;
                const users: Array<SelectOptionType<string>> = [];

                for(let i = 0, l = localUsers.length; i < l; i++) {
                    if(localUsers[i].is_api_user) {
                        continue;
                    }

                    const option: SelectOptionType<string> = {
                        value: localUsers[i].uuid,
                        label: localUsers[i].name,
                    };

                    if(localUsers[i].uuid === user) {
                        prevSelected = option;
                    }

                    users.push(option);
                }

                setSelected(prevSelected);
                setOptions(users);
                setLoading(false);
            });
    }, [ user ]);

    let content;

    if(loading) {
        content = (
            <div className="m-8 text-xl">
                <FontAwesomeLight icon="spinner-third" spin />
            </div>
        );
    } else {
        content = (
            <Select
                value={selected}
                options={options}
                onChange={(option: SelectOptionType<string>) => {
                    setSelected(option);
                }}
                placeholder="Select User"
            />
        );
    }

    return (
        <div>
            {content}
            <div className="buttons">
                <Button
                    type="button"
                    classes={[ "button-cancel" ]}
                    onClick={() => {
                        dispatch(hideDialog());
                    }}
                >
                    Cancel
                </Button>
                <Button
                    type="button"
                    classes={[ "button-save" ]}
                    disabled={!selected || loading}
                    onClick={() => {
                        if(!selected) {
                            return;
                        }

                        onSelect(selected.value);
                        dispatch(hideDialog());
                    }}
                >
                    Select
                </Button>
            </div>
        </div>
    );
};
